var audio_rtlignore_default = {
  "fontElementMap": "LleDC",
  "customPlayer": "Fi1OT",
  "customPlayer_basic": "X8--6",
  "customPlayer_mobile": "tBWSH",
  "audio_coverImg": "BuO6T",
  "audio_small_cover_image": "dNyeF",
  "audio_icon_button": "BVcmZ",
  "audio_contextMenu_wrapper": "eqOwn",
  "customPlayer_with_image": "U9l-P",
  "track_wrapper": "_9jEKM",
  "trackContainer": "hqftN",
  "audio_download_icon": "MrIDU",
  "audio_duration": "_7B9kE",
  "customPlayer_small_fit": "-Xgxd",
  "track_sliders_wrapper": "cQd90",
  "audio_volume_wrapper": "xg5CA",
  "volume_slider_wrapper": "TQYek",
  "audioDetails": "kg8Q0",
  "title": "AQ8Nt",
  "author_name": "XPE5a",
  "dropdown_menu_wrapper": "lDken",
  "dropdown_selected_button": "-QJjo",
  "dropdown_content": "qMgYI",
  "dropdown_content_withIcon": "U998x",
  "audio_loader_icon": "Yg7x8",
  "spin": "_5Z5Mm"
};
export {
  audio_rtlignore_default as default
};
//# sourceMappingURL=audio.rtlignore-scss.js.map
